var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Flash = function Flash(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.376 2.073a1 1 0 0 1 .614 1.068L13.153 9H19a1 1 0 0 1 .809 1.588l-8 11a1 1 0 0 1-1.799-.73L10.847 15H5a1 1 0 0 1-.809-1.588l8-11a1 1 0 0 1 1.185-.339ZM6.964 13H12a1 1 0 0 1 .99 1.141l-.43 3.015L17.035 11H12a1 1 0 0 1-.99-1.141l.43-3.015L6.965 13Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Flash;